const MAX_RETRIES = 5;
const RETRY_DELAY = 1000; // 1 second

export const retrySupabaseOnFail = async <T>(
  operation: () => T | Promise<T>
): Promise<T> => {
  for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
    try {
      return await operation();
    } catch (error) {
      
      if (attempt === MAX_RETRIES) {
        throw error;
      }
      
      await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY));
    }
  }
  throw new Error("Max retries reached");
};